import React from "react";

const ClampedText = ({ value, className = "", as = "div", title }) => {
  const Tag = as;
  const stringValue = value === null || value === undefined ? "" : String(value);
  return (
    <Tag className={`line-clamp-2 break-words ${className}`.trim()} title={title ?? stringValue}>
      {stringValue}
    </Tag>
  );
};

export default ClampedText;


